// The service worker (scripts/sw-template.js, written to dist/sw.js by the
// build) keeps the site on the device, so a page the phone unloaded while
// another app was in front opens again without a connection.

/** Register the worker once the page has loaded (production builds only). */
export function registerOffline(): void {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* Private browsing or an old browser: the site still works online. */
    });
  });
}

let warmed = false;

/**
 * Ask the worker to keep the rest of the site too (every course, the
 * in-browser engine): called when a trainer opens, so a game started on the
 * ground can go on, or move to another course, in the air.
 */
export function keepSiteOffline(): void {
  if (warmed || !import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  warmed = true;
  void navigator.serviceWorker.ready.then((registration) =>
    registration.active?.postMessage({ type: "warm" })
  );
}
